import { formatPrice, projectHref } from '../lib/format.js';
import { Icon } from './Icon.jsx';

// One listing as a card: a real image (lazy, sized, described), the facts a
// buyer scans first, and the whole card as one link.
export function ProjectCard({ project: p, priority = false, badge: badgeProp }) {
  const badge = p.preview ? 'Draft preview' : badgeProp;
  const place = [p.sector, p.city].filter(Boolean).join(' · ');
  return (
    <a className="project-card" href={projectHref(p)} data-project={p.id} data-preview={p.preview ? '1' : undefined}>
      <div className="card-media">
        {p.hero_image
          ? <img src={p.hero_image} alt={`${p.name}${place ? `, ${place}` : ''}`} loading={priority ? 'eager' : 'lazy'} decoding="async" width="640" height="480" />
          : <span className="card-initial" aria-hidden="true">{String(p.name || '?').trim().charAt(0)}</span>}
        <span className="card-type-tag">{p.project_type}</span>
        {badge && <span className="top-pick-badge">{badge}</span>}
      </div>
      <div className="card-body">
        <h3>{p.name}</h3>
        <div className="card-locality">{place}</div>
        {p.developer_name && <div className="card-developer">{p.developer_name}</div>}
        <div className="card-price">{formatPrice(p)}</div>
        <div className="card-status">{p.status}</div>
        <div className="card-footer"><span>View project</span><Icon name="arrow" size={16} /></div>
      </div>
    </a>
  );
}

export function EmptyState({ children, action }) {
  return <div className="empty-state"><p>{children}</p>{action}</div>;
}
